import styled from 'styled-components'

export const SectionSeparator = styled.div`
	height: 1px;
	background-color: ${(props) => props.theme.colors.selectedTheme.newTheme.border.color};
	margin: 15px;
`

export const Pane = styled.div<{ noPadding?: boolean }>`
	box-sizing: border-box;
	height: 325px;
`
